import React from 'react'
import Popper from '@mui/material/Popper';
import Fade from '@mui/material/Fade';
import { Box } from '@mui/material';


const PopperComp = ({children , id , open , anchorEl}) => {

  return (
    <>
 \
      <Popper sx={{zIndex:'99999'}} id={id} open={open} anchorEl={anchorEl} transition>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Box sx={{ border: 1, p: 1, bgcolor: 'background.paper' }}>     
              {children}        
            </Box>
          </Fade>
        )}
      </Popper>
\
    </>
  )
}

export default PopperComp
